import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
//-------------------------------------------------
import magnifierImg from "src/img/magnifier.png";
import Resize from "src/components/common/resize";
import { useMyStore } from "src/components/main/mainStore";
import {
    MyFormData, 
    myAxios, 
    getTimeStamp,
    defaultPath,
    appTitle, 
} from "src/components/common/functions";
//-------------------------------------------------
export default function ErrorLog({ tabTitle }){
    const splitContent = (content) => {
        const output = content.split("\n");
        if(output.at(-1) === "") output.pop();
        return output;
    }
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const curUser = useMyStore(state => state.user);
    //-------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    const [rootPath, setRootPath] = useState(""); // `${defaultPath}/besstestlab`
    const [data, setData] = useState([]);
    const [showLoading, setShowLoading] = useState(true);
    const [renderSwitch, setRenderSwitch] = useState(true);
    const [filterWords, setFilterWords] = useState("");
    const filteredData = data.filter(item => filterWords === ""?true:JSON.stringify(item).toLowerCase().includes(filterWords));
    //-------------------------------------------------
    const highlightLinks = (content) => {
        const regex = /\/home4\/liux3216\/api\.junliu\.space\/.*?\.php/g;
        const parts = content.split(regex);
        const matches = content.match(regex);
        const result = [];
        for(let i = 0; i < parts.length; i++){
            result.push(parts[i]); // Add plain text
            if(matches && matches[i]){
                // Add highlighted URL
                result.push(
                <Link key = {i} to = {`/FileExplorer?path=${matches[i].replace(defaultPath, "")}`}>
                    {matches[i]}
                </Link>
                );
            }
        }
        return result;
    }
    const highlightFolderPath = (content) => {
        const folderPath = content.split("/").slice(0, -1).join("/");
        const filePath = content.split("/").slice(-1).join("/");
        const result = [];
        result.push(
            <Link key = {folderPath} to = {`/FileExplorer?path=${folderPath.replace(defaultPath, "")}`}>
                {folderPath}
            </Link>
            );
        result.push("/" + filePath);
        return result;
    }
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            //------------------------
            setShowLoading(true);
            const formData = new MyFormData();
            formData.append("rootPath", rootPath);
            const res = await myAxios("server/error_log.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            setData(res.data);
        }
        getData();
        return () => {
            isMounted = false;
            setShowLoader(false);
        }
    }, [renderSwitch, rootPath, updateDateTime, setShowLoader]);
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //-------------------------------------------------
    return (
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: curUser.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                        }}
                    />
                    <img
                        alt = ""
                        src = {magnifierImg}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "path">Path:</label>
                    <select
                        id = "path"
                        className = "form-control w-auto ml-2"
                        value = {rootPath}
                        onChange = {e => {
                            setRootPath(e.currentTarget.value);
                        }}
                    >
                        <option value = {`${defaultPath}/besstestlab`}>Bess Utility Solutions</option>
                        <option value = {`${defaultPath}/bessmti`}>Material Testing Inspection</option>
                        <option value = {""}>All</option>
                    </select>
                </span>
            </div>
            <div className = "cssContent pb10">
            {showLoading?<div className = "cssLoading">Loading...</div>:
            !filteredData.length?<div className = "cssLoading">All Good</div>:
            <div>
               {filteredData.map((item, index) => 
               <div key = {index}>
                    <div className = "h5 text-break">
                        {highlightFolderPath(item.path)}
                        <span
                            className = "ml-2 btn btn-danger"
                            onClick = {async() => {
                                if(!window.confirm("Are you sure to delete this file?")) return;
                                const formData = new MyFormData();
                                formData.append("action", "delete");
                                formData.append("path", item.path);
                                //------------------------
                                setShowLoader(true);
                                const res = await myAxios("server/error_log.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                //------------------------
                                setRenderSwitch(s => !s);
                            }}
                        >
                            x
                        </span>
                    </div>
                    {item.content?
                    <div className = "cssNotes text-secondary p-2 border rounded">
                        {splitContent(item.content).map((part, partIndex) => 
                        <p
                            key = {partIndex}
                            className = "my-2"
                        >
                            {highlightLinks(part)}
                            <span
                                className = "ml-2 btn btn-danger"
                                onClick = {async() => {
                                    // if(!window.confirm("Are you sure to delete this line?")) return;
                                    const newContent = [...item.content.split("\n").slice(0, partIndex), ...item.content.split("\n").slice(partIndex + 1)].join("\n");
                                    const formData = new MyFormData();
                                    formData.append("action", "partDelete");
                                    formData.append("path", item.path);
                                    formData.append("content", newContent);
                                    setShowLoader(true);
                                    const res = await myAxios("server/error_log.php", formData);
                                    setShowLoader(false);
                                    if(!res) return;
                                    setData(data.map(thisItem => thisItem.path === item.path?({
                                        ...item, 
                                        content: newContent
                                    }):thisItem));
                                }}
                            >
                                x
                            </span>
                        </p>)
                        }
                    </div>
                    :<></>}
               </div>)}
            </div>
            }
            </div>
        </div>
    )
}